import React from 'react';
import { TypedMemo } from '../../common/types';
import { Panel, PanelHead } from '../components/primitives/Panel';
import { ErrorView } from '../../common/views/ErrorView/ErrorView';
import { ErrorViewProps } from '../../common/views/ErrorView/props';
import styles from './SMLWatchlistView.module.scss';

interface WatchlistSectionProps {
  icon: React.ReactNode;
  title: string;
  exportButton: React.ReactNode;
  search: React.ReactNode;
  error: ErrorViewProps['error'] | null;
  retry: () => void;
  children: React.ReactNode;
}

/** One followed list (Playlists, Tracks or Artists): the head, the search-to-follow field, the table. */
const WatchlistSectionComponent: React.FC<WatchlistSectionProps> = ({
  icon,
  title,
  exportButton,
  search,
  error,
  retry,
  children,
}) => (
  <Panel className={`${styles.section} mb-4`}>
    <PanelHead icon={icon} title={title} right={exportButton} />
    <div className={styles.sectionBody}>
      {search}
      {error !== null && error !== undefined ? <ErrorView error={error} retry={retry} /> : children}
    </div>
  </Panel>
);

export const WatchlistSection = TypedMemo(WatchlistSectionComponent);
